var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"modals"}},[_c('el-dialog',{attrs:{"id":`${_vm.name}-barcode-scanner`,"title":"Scan Barcode","visible":_vm.scanning,"append-to-body":_vm.appendToBody},on:{"update:visible":_vm.close,"opened":_vm.scan,"closed":_vm.close}},[_c('div',{ref:"viewport",staticClass:"viewport"},[_c('canvas',{staticClass:"drawing"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }